import { render, staticRenderFns } from "./EditAwards.vue?vue&type=template&id=2b99dced&scoped=true"
import script from "./EditAwards.vue?vue&type=script&lang=js"
export * from "./EditAwards.vue?vue&type=script&lang=js"
import style0 from "./EditAwards.vue?vue&type=style&index=0&id=2b99dced&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b99dced",
  null
  
)

export default component.exports